module.exports = __webpack_public_path__ + "static/media/mi.326cb1bf.png";